import { gsap } from 'gsap';
import { Flip } from 'gsap/Flip';

document.addEventListener( 'DOMContentLoaded', function () {
  gsap.registerPlugin( Flip );

  const cards = document.querySelectorAll( '.therapeutic-card' );
  const grid = document.querySelector( '.therapeutic-grid' );
  let isAnimating = false;
  let currentHoveredCard = null;

  function checkIsMobile () {
    return window.innerWidth <= 1023;
  }

  let isMobile = checkIsMobile();

  window.addEventListener( 'resize', () => {
    isMobile = checkIsMobile();
  } );

  // Mobile: Click to expand functionality
  if ( isMobile ) {
    cards.forEach( card => {
      const toggleBtn = card.querySelector( '.mobile-toggle' );
      const description = card.querySelector( '.card-description' );

      if ( toggleBtn && description ) {
        toggleBtn.addEventListener( 'click', function ( e ) {
          e.preventDefault();
          e.stopPropagation();

          const isActive = description.classList.contains( 'active' );

          if ( isActive ) {
            // Close: slide down and fade out
            gsap.to( description, {
              y: 0,
              opacity: 0,
              maxHeight: 0,
              paddingTop: 0,
              duration: 0.6,
              ease: 'power3.Out',
              onComplete: () => {
                description.classList.remove( 'active' );
              }
            } );
            toggleBtn.classList.remove( 'active' );
          } else {
            // Open: slide down from top and fade in
            description.classList.add( 'active' );
            gsap.fromTo( description, {
              y: -20,
              opacity: 0,
              maxHeight: 0,
              paddingTop: 0
            }, {
              y: 0,
              opacity: 1,
              maxHeight: 500,
              paddingTop: '1rem',
              duration: 0.6,
              ease: 'power3.Out'
            } );
            toggleBtn.classList.add( 'active' );
          }
        } );
      }
    } );

    // Exit early on mobile - no hover animations
    return;
  }

  // Define animation direction for each card's description
  const descriptionAnimations = {
    1: {
      x: -30,
      y: 0
    }, // Slide in from left
    2: {
      x: 0,
      y: 30
    }, // Slide in from bottom
    3: {
      x: 30,
      y: 0
    }, // Slide in from right
    4: {
      x: -30,
      y: 0
    }, // Slide in from left
    5: {
      x: 30,
      y: 0
    }, // Slide in from right
    6: {
      x: 0,
      y: 30
    }, // Slide in from bottom
    7: {
      x: 0,
      y: 30
    } // Slide in from bottom
  };

  // Define image positioning for each card
  const imagePositions = {
    1: {
      top: '0%',
      right: '-62%',
      width: '215%',
      height: '210%'
    },
    2: {
      top: '0%',
      right: '-40%',
      width: '138%',
      height: '210%'
    },
    3: {
      top: '-9%',
      right: '-38%',
      width: '142%',
      height: '210%'
    },
    4: {
      top: '0%',
      right: '-21%',
      width: '125%',
      height: '106%'
    },
    5: {
      top: '0%',
      right: '-45%',
      width: '165%',
      height: '100%'
    },
    6: {
      top: '1%',
      right: '-20%',
      width: '180%',
      height: '100%'
    },
    7: {
      top: '-7%',
      right: '-20%',
      width: '180%',
      height: '100%'
    }
  };

  const originalAreas = {
    1: '1 / 1 / 17 / 7',
    2: '1 / 7 / 9 / 15',
    3: '1 / 15 / 9 / 25',
    4: '9 / 7 / 17 / 19',
    5: '9 / 19 / 17 / 25',
    6: '17 / 1 / 25 / 13',
    7: '17 / 13 / 25 / 25'
  };

  const hoverStates = {
    1: {
      1: '1 / 1 / 19 / 13',
      2: '1 / 13 / 10 / 19',
      3: '1 / 19 / 10 / 25',
      4: '10 / 13 / 19 / 19',
      5: '10 / 19 / 19 / 25',
      6: '19 / 1 / 25 / 13',
      7: '19 / 13 / 25 / 25'
    },
    2: {
      1: '1 / 1 / 19 / 7',
      2: '1 / 7 / 13 / 19',
      3: '1 / 19 / 13 / 25',
      4: '13 / 7 / 19 / 19',
      5: '13 / 19 / 19 / 25',
      6: '19 / 1 / 25 / 13',
      7: '19 / 13 / 25 / 25'
    },
    3: {
      1: '1 / 1 / 19 / 7',
      2: '1 / 7 / 14 / 13',
      3: '1 / 13 / 14 / 25',
      4: '14 / 7 / 19 / 13',
      5: '14 / 13 / 19 / 25',
      6: '19 / 1 / 25 / 13',
      7: '19 / 13 / 25 / 25'
    },
    4: {
      1: '1 / 1 / 19 / 7',
      2: '1 / 7 / 7 / 17',
      3: '1 / 17 / 7 / 25',
      4: '7 / 7 / 19 / 19',
      5: '7 / 19 / 19 / 25',
      6: '19 / 1 / 25 / 13',
      7: '19 / 13 / 25 / 25'
    },
    5: {
      1: '1 / 1 / 19 / 7',
      2: '1 / 7 / 7 / 17',
      3: '1 / 17 / 7 / 25',
      4: '7 / 7 / 19 / 13',
      5: '7 / 13 / 19 / 25',
      6: '19 / 1 / 25 / 13',
      7: '19 / 13 / 25 / 25'
    },
    6: {
      1: '1 / 1 / 13 / 7',
      2: '1 / 7 / 7 / 15',
      3: '1 / 15 / 7 / 25',
      4: '7 / 7 / 13 / 19',
      5: '7 / 19 / 13 / 25',
      6: '13 / 1 / 25 / 17',
      7: '13 / 17 / 25 / 25'
    },
    7: {
      1: '1 / 1 / 13 / 7',
      2: '1 / 7 / 7 / 15',
      3: '1 / 15 / 7 / 25',
      4: '7 / 7 / 13 / 19',
      5: '7 / 19 / 13 / 25',
      6: '13 / 1 / 25 / 9',
      7: '13 / 9 / 25 / 25'
    }
  };

  // Positions/hoverStates above are a 7-card puzzle: each card's area is
  // sized assuming cards 5-7 exist to fill in the rest of the 24-column
  // grid. With only 4 cards, card 4's area stopped at column 19 (both at
  // rest and on every hover target), leaving an empty strip on the right
  // that cards 5-7 would have covered in the full layout. Stretch card 4
  // out to column 25 for this 4-card case only, leaving the shared 7-card
  // puzzle untouched for any page that uses the full set.
  if ( cards.length === 4 ) {
    originalAreas[ 4 ] = '9 / 7 / 17 / 25';
    hoverStates[ 1 ][ 4 ] = '10 / 13 / 19 / 25';
    hoverStates[ 2 ][ 4 ] = '13 / 7 / 19 / 25';
    hoverStates[ 3 ][ 4 ] = '14 / 7 / 19 / 25';
    hoverStates[ 4 ][ 4 ] = '7 / 7 / 19 / 25';
  }

  cards.forEach( ( card, index ) => {
    const cardNumber = index + 1;

    // Apply custom image positioning
    const cardImage = card.querySelector( '.card-image' );
    if ( cardImage ) {
      const imgPos = imagePositions[ cardNumber ];
      cardImage.style.top = imgPos.top;
      cardImage.style.right = imgPos.right;
      cardImage.style.width = imgPos.width;
      cardImage.style.height = imgPos.height;
    }

    card.addEventListener( 'mouseenter', function () {
      // If we're already hovering this card, do nothing
      if ( currentHoveredCard === cardNumber ) return;

      // Allow direct card-to-card transitions
      if ( isAnimating && currentHoveredCard !== null ) {
        // Skip the animation lock for card-to-card transitions
      } else if ( isAnimating ) {
        return;
      }

      isAnimating = true;
      currentHoveredCard = cardNumber;

      const description = card.querySelector( '.card-description' );
      const title = card.querySelector( '.card-title' );

      // Hide all other descriptions immediately
      cards.forEach( ( c ) => {
        if ( c !== card ) {
          const otherDesc = c.querySelector( '.card-description' );
          if ( otherDesc ) {
            gsap.set( otherDesc, {
              opacity: 0,
              maxHeight: 0,
              marginTop: 0
            } );
          }
        }
      } );

      // Capture current state including the grid container
      const state = Flip.getState( [ grid, ...cards ] );

      // Apply hover grid positions immediately
      cards.forEach( ( c, i ) => {
        const targetCard = i + 1;
        const newArea = hoverStates[ cardNumber ][ targetCard ] ||
          originalAreas[ targetCard ];
        c.style.gridArea = newArea;
        c.style.opacity = ( c === card ? 1 : 0.85 );
      } );

      // Animate with improved settings.
      // scale:false (the default) makes Flip tween the real width/height
      // instead of a transform:scale() matrix. Card aspect ratios change a
      // lot between resting and hover states, so a non-uniform scale (e.g.
      // scaleX 0.49 vs scaleY 0.89) visibly stretched the text/image/corners
      // during the transition; tweening real dimensions grows the card
      // cleanly instead.
      Flip.from( state, {
        targets: cards,
        duration: 0.6,
        ease: "power3.inOut",
        absolute: true,
        onComplete: () => {
          isAnimating = false;
        }
      } );

      // Prevent title from squishing during animation
      // if (title) {
      //     gsap.set(title, {
      //         willChange: 'transform',
      //         force3D: true
      //     });
      // }

      // Fade out all other descriptions first
      cards.forEach( ( c ) => {
        if ( c !== card ) {
          const otherDesc = c.querySelector( '.card-description' );
          const otherTitle = c.querySelector( '.card-title' );
          const otherImage = c.querySelector( '.card-image' );

          if ( otherDesc ) {
            gsap.to( otherDesc, {
              opacity: 0,
              maxHeight: 0,
              marginTop: 0,
              duration: 0.35,
              ease: 'power3.in'
            } );
          }
          if ( otherTitle ) {
            gsap.to( otherTitle, {
              // fontSize: '1.5rem',
              scale: 1,
              duration: 0.35,
              ease: 'power3.inOut'
            } );
          }
          if ( otherImage ) {
            gsap.to( otherImage, {
              opacity: 0,
              duration: 0.,
              ease: 'power3.in'
            } );
          }
        }
      } );

      // Show the hovered card's image
      const cardImage = card.querySelector( '.card-image' );
      if ( cardImage ) {
        gsap.to( cardImage, {
          opacity: 0.9,
          duration: 0.4,
          delay: 0.1,
          ease: 'power3.out'
        } );
      }

      // Animate title size increase on hover.
      // transformOrigin is anchored to the bottom (not center) so the title
      // only grows upward into the card's empty space above it, instead of
      // also growing downward into the description's margin below it.
      if ( title ) {
        gsap.set( title, {
          willChange: 'transform, width',
          force3D: true,
          transformOrigin: 'left bottom'
        } );
        gsap.to( title, {
          // fontSize: '48px',
          // maxWidth: '500px',
          scale: 1.35,
          duration: 0.35,
          ease: 'power3.out'
        } );
      }
      // Animate description with directional fade
      if ( description ) {
        const animation = descriptionAnimations[ cardNumber ];

        // Set initial state
        gsap.set( description, {
          x: animation.x,
          y: animation.y
        } );

        // Animate in
        gsap.to( description, {
          opacity: 1,
          maxHeight: 200,
          maxWidth: 200,
          marginTop: '1.5rem',
          x: 0,
          y: 0,
          duration: 0.35,
          delay: 0.2,
          ease: 'power2.out'
        } );
      }
    } );

    card.addEventListener( 'mouseleave', function () {
      // Only reset if we're not moving to another card
      // We'll let the next card's mouseenter handle the transition
      setTimeout( () => {
        // Check if we've moved to another card
        if ( currentHoveredCard === cardNumber ) {
          if ( isAnimating ) return;
          isAnimating = true;
          currentHoveredCard = null;

          const description = card.querySelector( '.card-description' );
          const title = card.querySelector( '.card-title' );
          const cardImage = card.querySelector( '.card-image' );

          // Capture current state
          const state = Flip.getState( [ grid, ...cards ] );

          // Reset to original grid positions immediately
          cards.forEach( ( c, i ) => {
            const targetCard = i + 1;
            c.style.gridArea = originalAreas[ targetCard ];
            c.style.opacity = 1;

            // Show all images when no card is hovered
            const img = c.querySelector( '.card-image' );
            if ( img ) {
              gsap.to( img, {
                opacity: 0.9,
                duration: 0.35,
                ease: 'power3.out'
              } );
            }
          } );

          // Animate back with improved settings
          Flip.from( state, {
            targets: cards,
            duration: 0.35,
            ease: "power3.inOut",
            absolute: true,
            onComplete: () => {
              isAnimating = false;
            }
          } );

          // Animate description fade-out faster
          if ( description ) {
            gsap.to( description, {
              opacity: 0,
              maxHeight: 0,
              marginTop: 0,
              x: 0,
              y: 0,
              duration: 0.35,
              ease: 'power3.in'
            } );
          }

          // Reset title size
          if ( title ) {
            gsap.to( title, {
              // fontSize: '1.5rem',
              // maxWidth: '290px',
              scale: 1,
              duration: 0.35,
              ease: 'power3.inOut'
            } );
          }
        }
      }, 50 ); // Small delay to check if moving to another card
    } );
  } );
  if ( grid && cards.length ) {
    grid.addEventListener( 'mouseleave', function () {
      if ( isAnimating ) return;
      isAnimating = true;
      currentHoveredCard = null;

      const state = Flip.getState( [ grid, ...cards ] );

      // Reset all cards to original positions and styles
      cards.forEach( ( c, i ) => {
        const targetCard = i + 1;
        c.style.gridArea = originalAreas[ targetCard ];
        c.style.opacity = 1;

        // Hide description
        const desc = c.querySelector( '.card-description' );
        if ( desc ) {
          gsap.to( desc, {
            opacity: 0,
            maxHeight: 0,
            marginTop: 0,
            x: 0,
            y: 0,
            fontSize: '0.95rem', // Ensure font size resets
            duration: 0.35,
            ease: 'power3.in'
          } );
        }

        // Reset title size
        const title = c.querySelector( '.card-title' );
        if ( title ) {
          gsap.to( title, {
            // fontSize: '1.5rem',
            // maxWidth: '290px',
            scale: 1,
            duration: 0.35,
            ease: 'power3.inOut'
          } );
        }

        // Reset image opacity
        const img = c.querySelector( '.card-image' );
        if ( img ) {
          gsap.to( img, {
            opacity: 0.9,
            duration: 0.35,
            ease: 'power3.out'
          } );
        }
      } );

      // Animate grid back to original
      Flip.from( state, {
        targets: cards,
        duration: 0.35,
        ease: "power3.inOut",
        absolute: true,
        onComplete: () => {
          isAnimating = false;
        }
      } );
    } );
  };
} );